<template>
  <div id="login">
    <div id="description">
      <h1>Login</h1>
      <p>Welcome to Romeflex Market Platform</p>
    </div>
    <div id="form">
      <form>
        <label for="username">Username</label>
        <input id="username" type="text" name="username" v-model="input.username" placeholder="username" />
        <label id="password" for="password">Password</label>
        <input type="password" name="password" v-model="input.password" placeholder="Password" autocomplete="off"/>
        <button type="button" v-on:click="doLogin()">Login</button>
        <!-- <router-link class="signup_text" to="/signup">Registrati</router-link> -->
      </form>
    </div>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService'

export default {
  name: 'login',
  data () {
    return {
      input: {
        username: '',
        password: ''
      }
    }
  },
  methods: {
    /* doLogin () {
      const params = {username: this.input.username, password: this.input.password}
      const navigate = this.$router
      const session = this.$session
      // console.log('Login Params' + JSON.stringify(params))
      AuthService.login(params)
        .then(async function (response) {
          console.log('Login ' + JSON.stringify(response.data))
          const user = response.data
          session.start()
          console.log(user)
          session.set('user', user)
          console.log(session)
          navigate.push('/home')
        }).catch(function (error) {
          console.log('Login Error', error)
          navigate.push('/')
        })
    } */
    doLogin () {
      const params = { username: this.input.username, password: this.input.password }
      const navigate = this.$router
      const session = this.$session

      if (!params.username || !params.password) {
        this.$bvToast.toast('Username e Password sono obbligatori.', {
          title: 'Errore',
          variant: 'danger',
          solid: true
        })
        return
      }

      AuthService.login(params)
        .then(async function (response) {
          console.log('Login ' + JSON.stringify(response.data))
          const user = response.data
          session.start()
          console.log(user)
          session.set('user', user)
          console.log(session)
          navigate.push('/home')
        })
        .catch(function (error) {
          console.log('Login Error', error)

          let errorMessage = 'Errore durante il login. Riprova più tardi.'

          if (error.response) {
            if (error.response.status === 403) {
              errorMessage = 'Username o password errati.'
            } else if (error.response.status === 401) {
              errorMessage = 'Accesso non autorizzato. Verifica le tue credenziali.'
            }
          }

          this.$bvToast.toast(errorMessage, {
            title: 'Errore',
            variant: 'danger',
            solid: true
          })
          navigate.push('/')
        }.bind(this))
    }
  }
}
</script>
<style>
  * {
    box-sizing: border-box;
    font-family: 'Nunito', sans-serif;
  }

  html,
  body {
    height: 100%;
    margin: 0;
    padding: 0;
    width: 100%;
  }

  div#app {
    width: 100%;
    height: 100%;
  }

  div#app div#login {
    align-items: center;
    background-color: #fff;
    display: flex;
    justify-content: center;
    width: 100%;
    height: calc(100% - 90px);
    margin-top: -20px;
  }

  div#app div#login div#description {
    border-style: solid;
    border-image: linear-gradient(to right, #af0f6a, #f7ac51) 1;
    background-color: #ffffff;
    width: 280px;
    padding: 35px;
  }

  div#app div#login div#description h1,
  div#app div#login div#description p {
    margin: 0;
    color: #af0f6a;
  }

  div#app div#login div#description p {
    font-size: 0.8em;
    color: #af0f6a;
    margin-top: 10px;
  }

  div#app div#login div#form {
    background: linear-gradient(90deg, rgba(175,15,106,1) 0%, rgba(230,25,126,1) 35%, rgba(247,172,81,1) 100%);
    border-radius: 5px;
    box-shadow: 0px 0px 30px 0px #666;
    color: #ecf0f1;
    width: 260px;
    padding: 35px;
  }

  div#app div#login div#form label,
  div#app div#login div#form input {
    outline: none;
    width: 100%;
  }

  div#app div#login div#form label {
    color: #ffffff;
    font-size: 0.8em;
  }

  div#app div#login div#form input {
    background-color: transparent;
    border: none;
    color: #ecf0f1;
    font-size: 1em;
    margin-bottom: 20px;
  }

  div#app div#login div#form ::placeholder {
    color: #ecf0f1;
    opacity: 1;
  }

  div#app div#login div#form button {
    background-color: #ffffff;
    cursor: pointer;
    border: none;
    padding: 10px;
    transition: background-color 0.2s ease-in-out;
    width: 100%;
    margin-bottom: 10px;
  }

  div#app div#login div#form button:hover {
    background-color: #eeeeee;
  }

  @media screen and (max-width: 600px) {
    div#app div#login {
      align-items: unset;
      background-color: unset;
      display: unset;
      justify-content: unset;
    }

    div#app div#login div#description {
      margin: 0 auto;
      max-width: 350px;
      width: 100%;
    }

    div#app div#login div#form {
      border-radius: unset;
      box-shadow: unset;
      margin: 0 auto;
    }

    div#app div#login div#form form {
      margin: 0 auto;
      max-width: 280px;
      width: 100%;
      margin: 0 auto;
    }
  }
  .signup_text {
    color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue